import FAQ from "./components/FAQ";
import { GlobalStyle } from "./index.styles";

function App() {
  return (
    <div className="App">
      <GlobalStyle />
      <FAQ />
    </div>
  );
}

export default App;
